import APP from 'src/main.js'
import Person from './Person.js'
class Administrator extends Person {
  get person_consultants(){
    return this.constructor.employeeStore.person_consultants.filter(rel => rel.employee_id === this.id)
  }
  get primary_person_consultants(){
    return this.person_consultants.filter(rel => rel.is_primary)
  }

  get person_consultants_consultants(){
    return this.constructor.employeeStore.person_consultants.filter(rel => rel.person_id === this.id)
  }
  get primary_person_consultants_consultants(){
    return this.person_consultants_consultants.filter(rel => rel.is_primary)
  }

  get primary_consultant_consultant(){
    let rels = this.person_consultants_consultants.filter(rel => rel.relation_type == 'primary')
    if(rels.length === 0){
      return null
    }
    return this.constructor.employeeStore.peopleById.get(rels[0].consultant_id)
  }

}
export default Administrator
